var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmnisend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.7 283.7",
    style: {
      enableBackground: "new 0 0 283.7 283.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.45,0H49.15c-27.1,0-49.1,22-49.1,49.1v185.3c0,27.1,22,49.1,49.1,49.1h20.7h63.7v-40.6c0-39.1-4.8-69.2-33.9-77.8v-32 c47.3,4.2,70.8,39.4,70.8,97.3v53.3h38.5h25.6c27.1,0,49.1-22,49.1-49.1V49.1C283.55,22,261.55,0,234.45,0 M143.25,102.4 c-15,0-27.2-12.2-27.2-27.2s12.2-27.2,27.2-27.2s27.1,12.2,27.1,27.3C170.35,90.3,158.25,102.4,143.25,102.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmnisend);
export default __webpack_public_path__ + "static/media/omnisend.85934758ebc4649059ef924de688b727.svg";
export { ForwardRef as ReactComponent };